module.exports = __webpack_public_path__ + "static/brain-hold-df9902946474b75192375b1de3dc3e7f.png";